import { ExecutiveDashboardServiceImpl } from '#services/executive-dashboard/executive-dashbord.service';
import { ExecutiveReportServiceImpl } from '#services/executive-report/executive-report.service';
import { Provider } from '@angular/core';
import { APP_TOKENS } from './app-tokens';

export const SERVICES_PROVIDERS: Provider[] = [
  {
    provide: APP_TOKENS.EXECUTIVE_DASHBOARD,
    useClass: ExecutiveDashboardServiceImpl
  },
  {
    provide: APP_TOKENS.EXECUTIVE_REPORT,
    useClass: ExecutiveReportServiceImpl
  }
];

export const provideServices = (providers: Provider[]) => [...SERVICES_PROVIDERS, ...providers];
